import qs from 'qs';
import { ADDONS } from '../../constants/endpoints';

export const RECEIVE_ADDONS = 'RECEIVE_ADDONS';
export const TOGGLE_ADDON_DISPLAY = 'TOGGLE_ADDON_DISPLAY';

export const fetchAddons = () => async (dispatch, getState) => {
  try {
    const {
      returnSubmission: { returnProcessInfo: { encrypted_return_id: encryptedReturnId } = {} } = {},
      retailerSettings: { name: retailerName } = {},
    } = getState();

    const { addons } = await fetch(
      ADDONS({ params: qs.stringify({ return_id: encryptedReturnId }), retailerName }),
    ).then((e) => e.json());

    if (!addons) throw new Error('Addons are missing');

    dispatch({
      type: RECEIVE_ADDONS,
      data: {
        addons,
        addonsDisplay: addons.reduce((acc, { option }) => ({ ...acc, [option]: true }), {}),
      },
    });
  } catch (err) {
    console.error(err);
  }
};

export const toggleAddonDisplay = (option) => ({
  type: TOGGLE_ADDON_DISPLAY,
  data: { option },
});
